<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2x"><a id="page_v"></a>Contents</h2>
<p class="toc1"><a href="#/xhtml/acknowledgments#ack">Acknowledgments</a></p>
<p class="toc1"><a href="#/xhtml/transliteration#tra">Note on Transliteration</a></p>
<p class="toc1t"><a href="#/xhtml/introduction#int">Introduction</a></p>
<p class="toc"><a href="#/xhtml/chapter01#ch1"><strong>1</strong> Competing Calls in Urban Morocco</a></p>
<p class="toc"><span href="#/xhtml/chapter02#ch2" title="Link target outside of Sample"><strong>2</strong> Nationalizing the Call: Trance, Technology, and Control</span></p>
<p class="toc"><span href="#/xhtml/chapter03#ch3" title="Link target outside of Sample"><strong>3</strong> Our Master’s Call: The Apotheosis of Moroccan Islam</span></p>
<p class="toc"><span href="#/xhtml/chapter04#ch4" title="Link target outside of Sample"><strong>4</strong> Summoning in Secret: Mute Letters and Veiled Writing</span></p>
<p class="toc"><span href="#/xhtml/chapter05#ch5" title="Link target outside of Sample"><strong>5</strong> Rites of Reception</span></p>
<p class="toc"><span href="#/xhtml/chapter06#ch6" title="Link target outside of Sample"><strong>6</strong> Trance-Nationalism, or, the Call of Moroccan Islam</span></p>
<p class="toc"><span href="#/xhtml/chapter07#ch7" title="Link target outside of Sample"><strong>7</strong> “To Eliminate the Ghostly Element Between People”: The Call as Exorcism</span></p>
<p class="toc1t"><span href="#/xhtml/epilogue#epi" title="Link target outside of Sample">Epilogue</span></p>
<p class="toc1t"><span href="#/xhtml/notes#not" title="Link target outside of Sample">Notes</span></p>
<p class="toc1"><span href="#/xhtml/references#ref" title="Link target outside of Sample">References</span></p>
<p class="toc1"><span href="#/xhtml/index#ind" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?6bf730e1